import { render, staticRenderFns } from "./ProjectSectionStoryStablePledge.vue?vue&type=template&id=65cfc623&"
import script from "./ProjectSectionStoryStablePledge.vue?vue&type=script&lang=js&"
export * from "./ProjectSectionStoryStablePledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports